// eslint-disable-next-line @eslint-community/eslint-comments/disable-enable-pair
/* eslint-disable camelcase */

'use client';

import classnames from 'classnames/bind';
import React, { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import { Button } from '@/_kit/button';
import { EButtonColor, EButtonSize } from '@/_kit/button/_types';
import { ArrowRightIcon } from '@/_kit/icons/arrow-right-icon';
import { EEducationProgram, ELinkId } from '@/_components/education/_types';
import { EAnalytics } from '@/_constants/analytics';
import { useAnalytics } from '@/_hooks/use-analytics';
import { ETextSize } from '@/_kit/text/_types';
import { Text } from '@/_kit/text';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'AllMaterialsButton';

type TProps = {
  link: string;
  blockName: EEducationProgram;
  buttonName: string;
};

export const AllMaterialsButton = ({ link, blockName, buttonName }: TProps) => {
  const translations = useTranslations();
  const sendEvent = useAnalytics();

  const isButtonWithStroke = blockName === EEducationProgram.PRO_WB;
  const strokeColor = isButtonWithStroke ? EButtonColor.BLACK : null;

  const handleButtonClick = useCallback(() => {
    const config = {
      name: EAnalytics.SUPPLIER_LANDING_PRO_WB_FARVATER_BANNER_T,
      params: {
        button_name: blockName,
        link_name: ELinkId.ALL_MATERIALS,
      },
    };

    sendEvent(config);

    window.open(link, '_blank');
  }, [blockName, link, sendEvent]);

  return (
    <div className={cn(BLOCK_NAME)}>
      <Button
        backgroundColor={EButtonColor.WHITE}
        onClick={handleButtonClick}
        rightIcon={ArrowRightIcon}
        size={EButtonSize.MEDIUM}
        strokeColor={strokeColor}
      >
        <Text
          size={ETextSize.SMALL}
          text={translations(buttonName)}
          variant="body"
        />
      </Button>
    </div>
  );
};
